import {
    SET_ORGANIZATION_LICENSES,
    SET_ORGANIZATION_ID,
    SET_ORGANIZATION_NAME,
    SET_ORGANIZATION_SUPPORT_EMAIL,
    SET_ORGANIZATION_PHONE_NUMBER,
    SET_ORGANIZATION_TIME_ZONE
} from '@/store/modules/activeOrganizationData/mutations'

const setOrganizationLicenses = ({ commit }, payload) => {
    commit(SET_ORGANIZATION_LICENSES, payload.licenses)
}

const setOrganizationId = ({ commit }, payload) => {
    commit(SET_ORGANIZATION_ID, payload.id)
}

const setOrganizationName = ({ commit }, payload) => {
    commit(SET_ORGANIZATION_NAME, payload.name)
}

const setOrganizationSupportEmail = ({ commit }, payload) => {
    commit(SET_ORGANIZATION_SUPPORT_EMAIL, payload.supportEmail)
}

const setOrganizationPhoneNumber = ({ commit }, payload) => {
    commit(SET_ORGANIZATION_PHONE_NUMBER, payload.phoneNumber)
}

const setOrganizationTimeZone = ({ commit }, payload) => {
    commit(SET_ORGANIZATION_TIME_ZONE, payload.timeZone)
}

export default {
    setOrganizationLicenses,
    setOrganizationId,
    setOrganizationName,
    setOrganizationSupportEmail,
    setOrganizationPhoneNumber,
    setOrganizationTimeZone
}
